import React, { useState, useEffect } from "react";
import { Divider, Input, Select, message, Button } from "antd";
import { postRequest, getRequest } from "../service/index";
import { getEmployeeData } from "../utils/localStorage";
import { countries } from '../constant/countery';

const AddSalary = ({ onClose }) => {
  const [amountType, setAmountType] = useState("percentage");
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const data = getEmployeeData();
  const currency = data?.currency;
  const country = countries.find(c => c.currency === currency);
  const currencySign = country ? country.currencySymbol : currency;

  const [formData, setFormData] = useState({
    title: "",
    type: "",
    amountType: "percentage",
    amount: "",
    employees: []
  });
  
  const typeOptions = [
    {
      label: "Allowances",
      value: "allowances",
    },
    {
      label: "Contributions",
      value: "contributions",
    },
    {
      label: "Deductions",
      value: "deductions",
    }
  ];

  const amountTypeOptions = [
    {
      label: "Percentage (%age)",
      value: "percentage",
    },
    {
      label: `Price (${currencySign})`,
      value: "price",
    },
  ];

  // Fetch employees on component mount
  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await getRequest('/api/companies/reportto');
      if (response?.employees) {
        const formattedOptions = response.employees.map(item => ({
          value: item._id,
          label: item.name
        }));
        setEmployeeOptions(formattedOptions);
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    // if (!formData.title || !formData.type || !formData.amount) {
    //   message.error('Please fill in all required fields');
    //   return;
    // }

    try {
      const response = await postRequest("/api/taxandbonus", formData);
      if (response.message === "Tax/Bonus entry created successfully") {
        message.success('Extra created successfully');
        onClose();
      } else {
        message.error(response.error || "Extra Not created");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSelectAll = (type, options) => {
    setFormData(prev => ({
      ...prev,
      [type]: options.map(opt => opt.value)
    }));
  };

  const handleUnselectAll = (type) => {
    setFormData(prev => ({
      ...prev,
      [type]: []
    }));
  };

  const getSelectOptions = (options, type) => {
    return [
      {
        label: (
          <div className="flex justify-between items-center">
            <span>Select All</span>
            <span className="text-xs text-gray-500">Select all options</span>
          </div>
        ),
        value: 'select-all',
        className: 'select-all-option'
      },
      {
        label: (
          <div className="flex justify-between items-center">
            <span>Unselect All</span>
            <span className="text-xs text-gray-500">Clear all selections</span>
          </div>
        ),
        value: 'unselect-all',
        className: 'unselect-all-option'
      },
      {
        type: 'divider'
      },
      ...options
    ];
  };

  const handleSelectChange = (type, value, options) => {
    if (value.includes('select-all')) {
      handleSelectAll(type, options);
    } else if (value.includes('unselect-all')) {
      handleUnselectAll(type);
    } else {
      handleInputChange(type, value.filter(v => v !== 'select-all' && v !== 'unselect-all'));
    }
  };

  return (
    <div className="grid grid-cols-12 space-x-4 space-y-4">
      <div className="flex flex-col col-span-12">
        <label className="text-md text-gray-400">Type</label>
        <Select
          className="w-full"
          options={typeOptions}
          placeholder="Select type"
          value={formData.type}
          onChange={(value) => handleInputChange("type", value)}
        />
      </div>

      <div className="flex flex-col col-span-12">
        <label htmlFor="name" className="text-md text-gray-400">
          Name
        </label>
        <Input
          placeholder="Enter name"
          value={formData.title}
          onChange={(e) => handleInputChange("title", e.target.value)}
        />
      </div>

      <div className="flex flex-col col-span-6">
        <label className="text-md text-gray-400 mb-1.5">Amount Type</label>
        <Select
          className="w-full"
          options={amountTypeOptions}
          value={formData.amountType}
          onChange={(value) => {
            setAmountType(value);
            handleInputChange("amountType", value);
          }}
          placeholder="Select amount type"
        />
      </div>

      <div className="col-span-6 flex flex-col gap-1">
        <label htmlFor="amount" className="text-md text-gray-400">
          Amount
        </label>
        <div className="flex items-center">
          <span className="border px-2 py-1 rounded-l-md border-secondary text-md bg-primary text-white">
            {amountType === "percentage" ? "%" : currencySign}
          </span>
          <Input
            className="!rounded-l-none"
            placeholder={amountType === "percentage" ? "Enter percentage" : "Enter amount"}
            value={formData.amount}
            onChange={(e) => handleInputChange("amount", e.target.value)}
          />
        </div>
      </div>

      <div className="flex flex-col col-span-12">
        <label className="text-md text-gray-400">Employees</label>
        <Select
          mode="multiple"
          className="w-full"
          options={getSelectOptions(employeeOptions, "employees")}
          placeholder="Select employees"
          value={formData.employees}
          onChange={(value) => handleSelectChange("employees", value, employeeOptions)}
          loading={loading}
          maxTagCount={3}
          maxTagTextLength={20}
        />
      </div>
      <Divider className="col-span-12 !p-0 !m-0" />
      <div className="col-span-12 flex items-center justify-end gap-3 mt-3">
        <Button onClick={onClose} >Cancel</Button>
        <Button 
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Add Extra
        </Button>
      </div>
    </div>
  );
};

export default AddSalary;
